module.exports = __webpack_public_path__ + "3384c7d7.png";